import { render, staticRenderFns } from "./PrintBadgeDialog.vue?vue&type=template&id=506cc698&"
import script from "./PrintBadgeDialog.vue?vue&type=script&lang=js&"
export * from "./PrintBadgeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports